(function () {
  'use strict';

  angular.module('app').component('prepaymentTypeLabel', prepaymentTypeLabel());

  function prepaymentTypeLabel() {
    return {
      bindings: {
        status: '<',
      },
      controller: PrepaymentTypeLabelComponent,
      controllerAs: 'vm',
      template:
        '<span>' + '<i class="fa fa-{{ vm.statusIcon }}"></i> {{ vm.statusTitle }}' + '</span>',
    };
  }

  PrepaymentTypeLabelComponent.$inject = ['$translate'];

  function PrepaymentTypeLabelComponent($translate) {
    const vm = this;

    vm.$onInit = function () {
      setStatusLabel();
    };

    function setStatusLabel() {
      // let statusClass = '';
      let statusIcon = '';
      let statusTitle = '';

      switch (vm.status) {
        case 'incoming':
          // statusClass = 'primary';
          statusIcon = 'arrow-down';
          statusTitle = 'INCOMING';
          break;
        case 'outgoing':
          // statusClass = 'default';
          statusIcon = 'arrow-up';
          statusTitle = 'OUTGOING';
          break;
      }

      vm.statusIcon = statusIcon;
      vm.statusTitle = $translate.instant(statusTitle);
    }
  }
})();
